var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHierarchical = function SvgHierarchical(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M5.55 16.675a1.024 1.024 0 0 1-1.495 0l-2.789-3a.99.99 0 0 1 .064-1.413 1.023 1.023 0 0 1 1.432.063l1.027 1.103V4c0-.553.453-1 1.014-1s1.014.447 1.014 1v9.428l1.027-1.106a1.026 1.026 0 0 1 1.432-.063.99.99 0 0 1 .064 1.413l-2.79 3zm5.337.325c-.56 0-1.014-.447-1.014-1s.454-1 1.014-1h1.015c.56 0 1.014.447 1.014 1s-.454 1-1.014 1zm0-4c-.56 0-1.014-.447-1.014-1s.454-1 1.014-1h3.043c.56 0 1.014.447 1.014 1s-.453 1-1.014 1zm0-4c-.56 0-1.014-.447-1.014-1s.454-1 1.014-1h5.07c.562 0 1.015.447 1.015 1s-.453 1-1.014 1zm0-4c-.56 0-1.014-.447-1.014-1s.454-1 1.014-1h7.099C18.546 3 19 3.447 19 4s-.453 1-1.014 1z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHierarchical);
export default ForwardRef;